import { BizsolState, GetMyBizsolStateQuery } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const getMyBizsolStateHandler = graphql.query<GetMyBizsolStateQuery>(
  "getMyBizsolState",
  ({ query, variables }) => {
    return HttpResponse.json({
      data: {
        me: {
          // bizsolState: BizsolState.Waiting,
          bizsolState: BizsolState.Master,
          // bizsolState: BizsolState.Admin,
          // bizsolState: BizsolState.Member,
          // bizsolState: null,
        },
      },
    });
  }
);
